import { forwardRef, type SVGProps } from 'react';

import type { LucideIcon } from 'lucide-react';

/**
 * Wraps a Lucide icon so it accepts the same SVGProps API as the old custom
 * SVG components. Key difference: sanitises `style={false}` → `undefined` so
 * React doesn't throw when callers use the common `style={cond && {...}}`
 * pattern.
 */
export function mkIcon(Icon: LucideIcon) {
  return forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
    ({ style, ...props }, ref) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <Icon ref={ref as any} {...props} style={style || undefined} />
    ),
  );
}
